import { addNoticeAction } from '../actions/NoticeActions';
import { NoticeTypesEnum } from '../enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../enums/MessageTypesEnum';
import { HAVE_PLAN_TO_CHOOSE } from '../../MainModule/constants/notices';

export const addNoticeHavePlanToChoose = () =>
  addNoticeAction({
    renderContent: HAVE_PLAN_TO_CHOOSE,
    noticeType: NoticeTypesEnum.ERROR,
    messageType: MessageTypesEnum.KNM_FILE_SIZE,
  });
